/* src/app/core/components/check-version/system-warnings-notification/system-warnings-notification.component.scss */
a {
  cursor: pointer;
}
/*# sourceMappingURL=system-warnings-notification.component-F4DTSV3R.css.map */
